<template>
  <div class='lib__form__announcement lib__form__announcement--sent'>
    <h2 class='lib__text-success'>
      <i class='far fa-check-circle'></i>
      {{ $t('common.confirmation.title', [title.toLowerCase()]) }}
    </h2>
    <p data-cy='send-confirmation-message'
       v-html="sendWithDelay ? $t('common.confirmation.willBeSent', [email]) : (multipleSend ? $t('common.confirmation.multipleSend', [email]) : $t('common.confirmation.send', [email]))">
    </p>
    <p v-html="$t('common.confirmation.helpText')" />
  </div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'send-confirmation' })
export default class SendConfirmation extends Vue {
  //#region [Props]
  @Prop({ type: String, required: true }) public readonly title!: string
  @Prop({ type: String, required: false }) public readonly email!: string
  @Prop({ type: Boolean, required: false, default: false }) public readonly multipleSend!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly sendWithDelay!: boolean
  //#endregion
}
</script>>
